export default "__VITE_ASSET__DGgV3ecq__"